import { isObject } from "@fraction/shared";
import cookie, { type CookieSerializeOptions } from "cookie";
import config from "src/config";

// store the cookies for three weeks
const ONE_MONTH = 60 * 24 * 30;

const COOKIE_SETTINGS_DEFAULT: CookieSerializeOptions = {
  maxAge: ONE_MONTH,
  domain: config.cookieDomain,
  path: "/",
  sameSite: "lax",
};

export function parseGoogleOptimizeCookie(optimizeCookie?: string): {
  google_optimize_experiment?: string;
  google_optimize_experiment_variant?: string;
} {
  if (!optimizeCookie) {
    return {};
  }

  const split = optimizeCookie.split(".");
  return {
    google_optimize_experiment: split[2],
    google_optimize_experiment_variant: split[4],
  };
}

export function getStoredCookies(): {
  url_params?: string;
  initial_href?: string;
  initial_referrer?: string;
  google_optimize_experiment?: string;
  google_optimize_experiment_variant?: string;
} {
  const existing = cookie.parse(document.cookie);

  return {
    ...parseGoogleOptimizeCookie(existing?._gaexp),
    url_params: existing._url_params,
    initial_href: existing.initial_href,
    initial_referrer: existing.initial_referrer,
  };
}

export function saveCookie(key: string, value: any, cookieSettings?: CookieSerializeOptions) {
  // biome-ignore lint: whatevs
  document.cookie = cookie.serialize(key, isObject(value) ? JSON.stringify(value) : value, {
    ...COOKIE_SETTINGS_DEFAULT,
    ...cookieSettings,
  });
}

export function getCookie(key: string) {
  const value = cookie.parse(document.cookie)[key];
  try {
    return JSON.parse(value);
  } catch (_err) {
    return value;
  }
}
